import React from 'react';
const rows = [['Deciding what to offer in three seconds, under pressure', 'A card for the figure, already graded'], ['“This feels silly” — and the experiment collapses', 'A gentler version and words that make “no” easy'], ['Experiments that end without landing', 'Closing questions on every card'], ['Rebuilding the group plan every week', '90- and 120-minute group formulas, ready'], ['Replaying the session on the drive home', 'A post-session reflection sheet to close the loop']];
export function CostOfInaction() {
  return <section className="w-full bg-sage-deep" data-id="element-74" data-mp="38vsgkf0ijl1g">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-75" data-mp="3dntnrmitqlkm">
        <h2 className="text-center font-display text-[28px] text-cream sm:text-4xl" data-id="element-76" data-mp="3dqeq0cn1b3iw">
          What another improvised session costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-sage-line" data-id="element-77" data-mp="3nnat22u5yxg2">
          <div className="grid grid-cols-2 text-center" data-id="element-78" data-mp="3sl2tjl8vjrvv">
            <div className="border-r border-sage-line bg-terra-deep px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-79" data-mp="3sjhyzvmk88y0">
              Improvising
            </div>
            <div className="bg-sage px-3 py-3 font-display text-base text-cream sm:text-lg" data-id="element-80" data-mp="39gljm5zo959k">
              Session Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-sage-line text-[12.5px] sm:text-sm" data-id="element-81" data-mp="30hqdetwmnv69">
              <div className="border-r border-sage-line px-3.5 py-3.5 text-cream/55 line-through decoration-terra/70" data-id="element-82" data-mp="13eczxfpeldw">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-cream" data-id="element-83" data-mp="3nfl8ner3jm69">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}